import React, { useState } from 'react';
import { 
  fetchQuizQuestions, 
  Difficulty, 
  QuestionsState
} from './API';

// Styling
import { 
  GlobalStyle,
  Wrapper 
} from './App.styles';

// Components
import QuestionCard from './components/QuestionCard';

export type AnswerObject = {
  question: string;
  answer: string;
  correct: boolean;
  correctAnswer: string;
};

const TOTAL_QUESTIONS = 10;

function App() {
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState<QuestionsState[]>([]);
  const [number, setNumber] = useState(0);
  const [userAnswers, setUserAnswers] = useState<AnswerObject[]>([]);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(true);

  //console.log(fetchQuizQuestions(TOTAL_QUESTIONS, Difficulty.EASY));
  console.log(questions);

  const startTrivia = async () => {
    setLoading(true);
    setGameOver(false);

    const newQuestions = await fetchQuizQuestions(
      TOTAL_QUESTIONS,
      Difficulty.EASY
    );

    setQuestions(newQuestions);
    setScore(0);
    setUserAnswers([]);
    setNumber(0);
    setLoading(false);
  }

  // Triggered when users select an answer
  const checkAnswer = (e: any) => {
    if(!gameOver) {
      // Getting users' answer
      const answer = e.currentTarget.value;

      // Checking users' answer
      const correct =  questions[number].correct_answer === answer;

      // Adding score if users' answer is correct
      if(correct) setScore((prev) => prev + 1);

      // Saving users' answer in the array
      const answerObject = {
        question: questions[number].question,
        answer,
        correct,
        correctAnswer: questions[number].correct_answer,
      };
      setUserAnswers((prev) => [...prev, answerObject]);
    }
  };

  // Triggered when users goes to the next question
  const nextQuestion = () => {
    // Moving on to the next question if not the last question
    const nextQuestion = number + 1;

    if(nextQuestion === TOTAL_QUESTIONS) {
      setGameOver(true);
    } else {
      setNumber(nextQuestion);
    }
  };

  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <h1>React Quiz App</h1>
        {gameOver || userAnswers.length === TOTAL_QUESTIONS ? (
          <button className="start" onClick={startTrivia}>Start</button>
        ) : null }
        {!gameOver ? 
          <p className="score">Score : {score}</p>
        : null }
        {loading ? <p>Loading Qustions ...</p> : null }
        {!loading && !gameOver && (
          <QuestionCard
            questionNumber={number + 1} /* number + 1 because I want to start questionNumber as 1, not 0. */
            totalQuestions={TOTAL_QUESTIONS}
            question={questions[number].question}
            answers={questions[number].answers}
            userAnswer={userAnswers ? userAnswers[number] : undefined}
            callback={checkAnswer}
          />
        )}
        {!gameOver && !loading && 
          userAnswers.length === number + 1 && 
          number !== TOTAL_QUESTIONS -1 ? (
            <button className="next" onClick={nextQuestion}>
              Next Question
            </button>
        ) : null }
      </Wrapper>
    </>
  );
}

export default App;
